import { Delete } from "@mui/icons-material";
import { useState } from "react";

import useService from "../../../../hooks/useService";
import CustomIconButton from "../../../ui library/components/buttons/CustomIconButton";

import ProviderTypes from "./ProviderType";
import ReferralFrom from "./ReferralFrom";
import ReferralTo from "./ReferralTo";
import ReferredDate from "./ReferredDate";
import Source from "./Source";

export default function AddReferralItem({ caseId, onDelete, onChange }) {
  const providerRepository = useService("repositories/provider-repository");
  const fieldOptionRepository = useService("repositories/field-option-repository");
  const providerTypesRepository = useService("repositories/provider-type-repository");

  const providerClientStatusRepository = useService(
    "repositories/provider-client-status-repository"
  );

  const [referralTo, setReferralTo] = useState(null);

  return (
    <div className="flex w-full flex-row justify-center gap-4 bg-white p-2 shadow-md">
      <div className="w-48">
        <ReferralFrom
          caseId={caseId}
          repository={providerRepository}
          onChange={onChange}
        />
      </div>
      <div className="w-48">
        <ReferralTo
          repository={providerRepository}
          onChange={(field, value) => {
            onChange(field, value?.id ?? null);
            if (field === "referralTo") {
              setReferralTo(value);
            }
          }}
        />
      </div>
      <div className="w-48">
        <ProviderTypes
          key={referralTo?.id}
          repository={providerTypesRepository}
          referralTo={referralTo}
          onChange={onChange}
          providerTypes={referralTo === null ? [] : referralTo?.providerTypes || []}
        />
      </div>
      <div className="w-48">
        <ReferredDate onChange={onChange} />
      </div>
      <div className="w-48">
        <Source repository={fieldOptionRepository} onChange={onChange} />
      </div>
      <div>
        <CustomIconButton
          classes="p-2"
          iconVisible={true}
          CustomIcon={<Delete className="text-red-500" />}
          handleOnClick={onDelete}
        />
      </div>
    </div>
  );
}
